import React, { Fragment } from "react";

import { Form } from "react-router-dom";

import { Menu, Transition } from "@headlessui/react";

import { convertToTitleCase } from "../actions/dataFormatter";
import EllipsesHorizontalIcon from "../assets/icons/EllipsesHorizontalIcon";
import UserIcon from "../assets/icons/UserIcon";

const ProfileDropdown = ({ username }) => {
  return (
    <div className="w-full">
      <Menu as="div" className="relative block text-left">
        <div>
          <Menu.Button
            className={`flex items-center justify-between w-[95%] mx-auto rounded-lg py-2 hover:bg-zinc-900 cursor-pointer`}
          >
            <div className="px-2 flex gap-2 text-md items-center w-4/5">
              <div>
                <UserIcon className="rounded-full h-6 w-6" />
              </div>
              <h3 className="text-sm truncate">
                {convertToTitleCase(username)}
              </h3>
            </div>

            <div>
              <EllipsesHorizontalIcon className="w-4 h-4 mr-2" />
            </div>
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute bottom-full left-2 mt-2 w-56 divide-y divide-gray-100 rounded-md bg-zinc-800  shadow-lg ring-1 ring-zinc-700 focus:outline-none">
            <div className="">
              <Menu.Item>
                {({ active }) => (
                  <Form action="/logout" method="post">
                    <button
                      className={`${
                        active
                          ? "bg-zinc-700 border-zinc-900 text-white"
                          : "text-gray-900"
                      } group flex w-full items-center rounded-md p-2 text-sm text-white`}
                    >
                      Logout
                    </button>
                  </Form>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default ProfileDropdown;
